<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!'
})

const faqs = [
  {
    question: 'Apa Itu Pengiriman Kargo?',
    answer:
      '<p>Pengiriman kargo adalah layanan pengiriman barang dalam jumlah besar dengan berat dan volume tinggi. Barang dikirim melalui jalur darat (truk, kereta api), laut (kapal), atau udara (pesawat) untuk jarak jauh, seperti antar kota, provinsi, atau pulau. Layanan ini menjadi alternatif ideal untuk pengiriman barang berat atau muatan besar.</p>'
  },
  {
    question: 'Kenapa Ongkir Kargo Lebih Murah?',
    answer:
      '<p>Tarif pengiriman kargo lebih murah karena:<br /><br />1. Minimum Berat: Ada batas berat minimum yang mengoptimalkan biaya pengiriman.<br />2. Volume Besar: Barang dikirim dalam jumlah besar sehingga biaya distribusi per unit barang menjadi lebih rendah.</p>'
  },
  {
    question: 'Apakah Jasa Pengiriman Kargo Aman?',
    answer:
      '<p>Ya, jasa pengiriman kargo aman. Meski tarifnya lebih murah, layanan ini didukung dengan standar pengemasan dan pengiriman yang memastikan barang sampai dengan selamat. KiriminAja bekerja sama dengan ekspedisi terpercaya untuk menjaga keamanan barang Anda.</p>'
  },
  {
    question: 'Apa Bedanya Ekspedisi/Pengiriman Reguler dan Kargo?',
    answer:
      '<p>1. Pengiriman Reguler: Cocok untuk barang kecil dengan berat dan volume rendah, seperti dokumen atau paket kecil.<br />2. Kargo: Dirancang untuk barang besar dan berat dalam jumlah banyak, menggunakan moda transportasi darat, laut, atau udara.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Solusi Pengiriman Volume Besar untuk Bisnis Kamu"
      sub-title="Pengiriman Kargo ke Seluruh Indonesia"
      description="Lebih hemat ongkir untuk kirim paket yang berat maupun berdimensi besar. Paket bisa dijemput, siap kirim melalui berbagai jalur pengiriman."
      hero-image="/images/batch-2/cargo-welcome.avif"
      button-label="Kirim Paket Sekarang"
      :button-link="$utm.utmUrl(WEB_APP_URL)"
    />
    <LayananKargoBenefit />
    <LayananKargoKirimPaketBesar />
    <LayananKargoCaraKirimPaket />
    <LayananKargoExpedition />
    <LayananPilihanLayanan />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
